import { Booking, createBookingDates } from '../Firebase/firebaseApi.ts';

function rangesOverlap(aStart: Date, aEnd: Date, bStart: Date, bEnd: Date): boolean {
  return aStart < bEnd && bStart < aEnd;
}

export function isStationBookedInList(
  bookings: Booking[],
  stationId: string,
  fromDate: string,
  toDate: string
): boolean {
  const from = new Date(fromDate);
  const to = new Date(toDate);
  return bookings.some((booking) => {
    if (String(booking.stationId) !== String(stationId)) return false;
    return rangesOverlap(from, to, new Date(booking.fromDate), new Date(booking.toDate));
  });
}

/** Build from/to for each date in a series (same times / day hours). */
export async function buildSeriesRanges(
  dates: string[],
  slotType: string,
  startTime?: string,
  endTime?: string
): Promise<{ fromDate: string; toDate: string }[]> {
  const ranges: { fromDate: string; toDate: string }[] = [];
  for (const date of dates) {
    ranges.push(
      await createBookingDates(slotType, date, date, startTime, endTime)
    );
  }
  return ranges;
}

/** Station is available only if free for every range. */
export function isStationFreeForRanges(
  bookings: Booking[],
  stationId: string,
  ranges: { fromDate: string; toDate: string }[]
): boolean {
  return !ranges.some((range) =>
    isStationBookedInList(bookings, stationId, range.fromDate, range.toDate)
  );
}

/** Dates in the series that conflict for this station (`dates` and `ranges` same order). */
export function getConflictDates(
  bookings: Booking[],
  stationId: string,
  dates: string[],
  ranges: { fromDate: string; toDate: string }[]
): string[] {
  const conflicts: string[] = [];
  for (let i = 0; i < dates.length; i++) {
    const range = ranges[i];
    if (!range) continue;
    if (isStationBookedInList(bookings, stationId, range.fromDate, range.toDate)) {
      conflicts.push(dates[i]);
    }
  }
  return conflicts;
}
